module.exports = __webpack_public_path__ + "img/label-staff-blue.fface48d.svg";